<script setup>
import { useContentStore } from './stores/contentStore';
import LoadingScreen from './components/Loading/LoadingScreen';
import Background from './components/Background/Background.vue';
import Header from './components/Header/Header.vue';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';

const router = useRouter();
const contentStore = useContentStore();

onMounted(async () => {
    await router.isReady();
    const skipMediaPreload = router.currentRoute.value.query['skip_media_preload'] === 'true';
    contentStore.loadContent(skipMediaPreload);
})

</script>

<template>
    <LoadingScreen
        v-if="contentStore.isLoading"
        :loading-state="contentStore.loadingState"
    />

    <main class="h-full flex flex-col" v-else>
        <Background />
        <Header />
        <RouterView :key="$route.fullPath" />
    </main>
</template>